import { render, staticRenderFns } from "./grammar-icon.vue?vue&type=template&id=7114b4ce&"
import script from "./grammar-icon.vue?vue&type=script&lang=js&"
export * from "./grammar-icon.vue?vue&type=script&lang=js&"
import style0 from "./grammar-icon.vue?vue&type=style&index=0&id=7114b4ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports